$(document).ready(function () {

   jQuery(document).on('click', 'button.prod-meta-accordion-btn', function(){
          jQuery(this).toggleClass('active');
          jQuery(this).children('.cust-arrow').fadeToggle('medium');
          jQuery(this).siblings('.prod-meta-accordion-content').slideToggle('medium');
        });
        
        jQuery(document).on('click', '#prod_popup_video', function(){
          //jQuery('#cust-pop-video').addClass('active');
          jQuery('.cust-pro-video-wrapper').slideToggle('medium');
          
        });
  
  if ($(window).width() <= 720 )
    {
      $(document).on('click','.person-img',function(){
        $('.person-content').hide();
      	$(this).siblings('.person-content').css('display','block');
      })
    }

    var placeholder_url = '//affinage-professional.myshopify.com/cdn/shop/t/45/assets/affinage-logo-sqr.png?v=105987493445790042701739266404';

    var feed = new Instafeed({
      get: "user",
      userId: window.instafeed.userId,
      accessToken: window.instafeed.accessToken,
      limit: window.instafeed.limit,
      resolution: "standard_resolution",
      template: '<div class="block4 wrap-pic-w" >'+
      '<img data-src="\{\{image\}\}" class="lazyload \{\{orientation\}\}">'+
      '<a href="\{\{link\}\}" target="_blank" class="block4-overlay sizefull ab-t-l trans-0-4">'+
      '<div class="block4-overlay-txt trans-0-4 p-t-20 p-l-20 p-r-20 p-b-20 ab-t-l">'+
      '<p class="s-text10 of-hidden">\{\{caption\}\}</p>'+
      '</div>  </a>  </div>',
      target: "instafeed",
      success: function(response){},
	  after: function () {
        $("#instagram_block_home .flex-w").owlCarousel({
          autoPlay: false,
          items: window.instafeed.no_of_products,
          loop: true,
          autoHeight: false,
          navSpeed: 1000,
          dotsSpeed: 1000,
          autoplaySpeed: 1000,
          nav: false,
          dots: true,
          onInitialized: function(){
          	  new LazyLoad({ elements_selector: ".lazyload" });
          },
          navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
          responsive: {
            0: { items: 1 },
            480: { items: 2 },
            640: { items: 3 },
            991: { items: 4 },
            1200: { items: window.instafeed.no_of_products }
          }
      });
      
      //new LazyLoad({ elements_selector: ".lazyload-instafeed" });
    }
  
  });

  feed.run();
  

  
  $(".selection-1").select({
    minimumResultsForSearch: 20,
    dropdownParent: $('#dropDownSelect1')
  });

  $('.block2-btn-addwishlist').each(function(){
    var nameProduct = $(this).parent().parent().parent().find('.block2-name').html();
    $(this).on('click', function(){
      swal(nameProduct, "is added to wishlist !", "success");
    });
  });

  //$('.parallax100').parallax100();

  var moneyFormat = '';

});

$(document).ready(function () {
	new LazyLoad({ elements_selector: ".lazyload" });
  $('#showMoreTrigger').click(function(){
    $(this).addClass('open');
    $('.ambassadors-section').addClass('active');
  });
});